const ACTION = {
    UPDATE_IDPHOTO_ONE: 'UPDATE_IDPHOTO_ONE',
    UPDATE_IDPHOTO_ONE_PREVIEW_URL: 'UPDATE_IDPHOTO_ONE_PREVIEW_URL',
    UPDATE_IDPHOTO_TWO: 'UPDATE_IDPHOTO_TWO',
    UPDATE_IDPHOTO_TWO_PREVIEW_URL: 'UPDATE_IDPHOTO_TWO_PREVIEW_URL',
    UPDATE_ERROR_TEXT_ONE: 'UPDATE_ERROR_TEXT_ONE',
    UPDATE_ERROR_TEXT_TWO: 'UPDATE_ERROR_TEXT_TWP',
    UPDATE_IDPHOTO_TOTAL_ERROR_TEXT: 'UPDATE_IDPHOTO_TOTAL_ERROR_TEXT',
}

export default ACTION;